module.exports = __webpack_public_path__ + "static/media/hand-scissors.b163c251.svg";